import React from 'react';
import { Star, Shield, Zap, Award, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  // Function to scroll to pricing section
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="pt-16 md:pt-24 pb-8 md:pb-16 px-4 bg-leather" data-id="element-121">
      <div className="max-w-7xl mx-auto" data-id="element-122">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-12 items-start" data-id="element-123">
          {/* Left Column - Main Content */}
          <div className="lg:col-span-3" data-id="element-124">
            {/* Main Hero Heading */}
            <h1 className="text-2xl md:text-5xl lg:text-7xl font-black text-[#E4D6B5] leading-tight mb-4 md:mb-8 uppercase tracking-tight" data-id="element-125">
              Aprende el método de los muebles plegables y crea tus primeras
              piezas en solo{' '}
              <span className="text-[#8B5A2B] drop-shadow-[0_4px_8px_rgba(0,0,0,0.9)]" data-id="element-126">
                48 HORAS
              </span>
            </h1>

            {/* Subheading */}
            <h2 className="text-base md:text-xl lg:text-2xl text-[#C8B894] mb-4 md:mb-8 font-bold leading-relaxed" data-id="element-127">
              Accede al{' '}
              <span className="text-[#E4D6B5] font-black" data-id="element-128">
                Método Profesional de Carpintería Plegable
              </span>{' '}
              con <span className="text-[#E4D6B5] font-black" data-id="element-129">+200 Planos</span>{' '}
              con medidas exactas.
            </h2>

            {/* Hero Image */}
            <div className="relative bg-[#0a0a0a] border-2 md:border-4 border-[#6F6F6F] shadow-[0_0_40px_rgba(0,0,0,0.9)] mb-4 md:mb-8 overflow-hidden" data-id="element-130">
              <img src="https://cdn.shopify.com/s/files/1/1045/1160/3027/files/imagen_2026-02-16_132718062_1.webp?v=1771244858" alt="Máster en Carpintería Plegable" className="w-full h-auto" loading="eager" data-id="element-131" />
            </div>
            <p className="text-sm md:text-lg text-[#C8B894] mb-4 md:mb-8 font-semibold leading-relaxed" data-id="element-132">
              Para que dejes de improvisar y perder material y logres empezar a
              fabricar muebles plegables{' '}
              <span className="text-[#E4D6B5] font-black italic" data-id="element-133">
                que sí se venden.
              </span>
            </p>
          </div>

          {/* Right Column - Simplified Trust Signals */}
          <div className="lg:col-span-2" data-id="element-134">
            <div className="bg-metal border-2 border-[#6F6F6F] shadow-[0_0_40px_rgba(0,0,0,0.9)] p-3 md:p-6" data-id="element-135">
              {/* CTA Button - scrolls to pricing section (last offer) */}
              <a href="#pricing-section" onClick={e => {
              e.preventDefault();
              const pricingSection = document.getElementById('pricing-section');
              if (pricingSection) {
                pricingSection.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              }
            }} className="block mb-3 md:mb-4" data-id="element-136">
                <CTAButton text="QUIERO LOS +200 PLANOS ▶" size="large" className="w-full bg-[#4CAF50] hover:bg-[#45a049]" href="#pricing-section" data-id="element-137" />
              </a>

              {/* Simple Trust Bullets */}
              <div className="space-y-1.5 md:space-y-2 mb-3 md:mb-4 text-center" data-id="element-138">
                <p className="text-[10px] md:text-sm text-[#C8B894] font-semibold flex items-center justify-center gap-2" data-id="element-139">
                  <span data-id="element-140">🔒</span> Garantía 7 Días
                </p>
                <p className="text-[10px] md:text-sm text-[#C8B894] font-semibold flex items-center justify-center gap-2" data-id="element-141">
                  <span data-id="element-142">⚡</span> Acceso Inmediato
                </p>
                <p className="text-[10px] md:text-sm text-[#C8B894] font-semibold flex items-center justify-center gap-2" data-id="element-143">
                  <span data-id="element-144">📚</span> Actualizaciones diarias de por vida
                </p>
              </div>

              {/* Compact Rating */}
              <div className="bg-[#1a1a1a] border border-[#6F6F6F] rounded-lg p-2 md:p-3 flex items-center justify-between" data-id="element-145">
                <div className="flex items-center gap-1.5 md:gap-2" data-id="element-146">
                  <div className="flex gap-0.5" data-id="element-147">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 md:w-4 h-3 md:h-4 fill-[#FFD700] text-[#FFD700]" data-id="element-148" />)}
                  </div>
                  <span className="text-[#E4D6B5] font-bold text-xs md:text-sm" data-id="element-149">
                    4.9/5
                  </span>
                  <span className="text-[#C8B894] text-[10px] md:text-xs" data-id="element-150">
                    +2,554 Carpinteros
                  </span>
                </div>
                <div className="bg-[#4CAF50] rounded-full p-0.5 md:p-1" data-id="element-151">
                  <Check className="w-3 md:w-4 h-3 md:h-4 text-white" data-id="element-152" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}